// @flow
import React from 'react';
import { Field, reduxForm } from 'redux-form';
import { Prompt } from 'react-router-dom';

import Scrollable from '../shared/Scrollable';
import StyledForm from '../shared/StyledForm';

import Button from '../shared/Button';
import TextArea from '../shared/forms/TextArea';

let StandardTextEditForm = props => {
    const {
        handleSubmit,
        dirty,
        submitting,
        submitSucceeded,
        agreementTypes,
        insuranceTypes,
        defaultTextItems,
    } = props;

    return (
        <StyledForm onSubmit={handleSubmit}>
            <Prompt
                when={dirty && !submitSucceeded}
                message="You have made changes that will be lost if you proceed. Are you sure you want to continue?"
            />

            <Scrollable>
                <div className="flex">
                    <div className="col">
                        <h4>Property Agreement Types</h4>

                        {agreementTypes
                            ? Object.keys(
                                  agreementTypes
                              ).map(agreementTypeId => {
                                  return (
                                      <Field
                                          key={`agreementType-${agreementTypeId}`}
                                          name={`agreementType-${agreementTypeId}`}
                                          label={
                                              agreementTypes[agreementTypeId]
                                                  .propertyAgreementTypeName
                                          }
                                          component={TextArea}
                                          disabled={submitting}
                                      />
                                  );
                              })
                            : null}
                    </div>

                    <div className="col">
                        <h4>Property Insurance Types</h4>

                        {insuranceTypes
                            ? Object.keys(
                                  insuranceTypes
                              ).map(insuranceTypeId => {
                                  return (
                                      <Field
                                          key={`insuranceType-${insuranceTypeId}`}
                                          name={`insuranceType-${insuranceTypeId}`}
                                          label={
                                              insuranceTypes[insuranceTypeId]
                                                  .propertyInsuranceName
                                          }
                                          component={TextArea}
                                          disabled={submitting}
                                      />
                                  );
                              })
                            : null}

                        <h4>Other Standard Text</h4>

                        {defaultTextItems
                            ? Object.keys(
                                  defaultTextItems
                              ).map(defaultTextItemId => {
                                  const defaultTextItem =
                                      defaultTextItems[defaultTextItemId];

                                  return (
                                      <Field
                                          key={`defaultText-${defaultTextItem.defaultTextId}`}
                                          name={`defaultText-${defaultTextItem.defaultTextId}`}
                                          label={
                                              defaultTextItem.defaultTextTitle
                                          }
                                          component={TextArea}
                                          disabled={submitting}
                                      />
                                  );
                              })
                            : null}
                    </div>
                </div>
            </Scrollable>

            <div className="sticky-footer">
                <Button type="submit" disabled={submitting}>
                    {submitting ? 'Saving...' : 'Save'}
                </Button>
            </div>
        </StyledForm>
    );
};

export default reduxForm({
    form: 'standardTextEdit',
})(StandardTextEditForm);



// WEBPACK FOOTER //
// ./src/components/StandardText/Edit.js